export enum Order {
  'CONSTANT' = 'Constant',
  'ORDERED' = 'Ordered',
  'RANDOM' = 'Random',
  'CSV' = 'csv',
  'TIMESERIES' = 'TimeSeries',
  'TIMESTAMP' = 'TimeStamp',
  'DEVICEINFO' = 'DeviceInfo',
  'UNIQUEID' = 'UniqueId'
}
